import { Injectable } from '@angular/core';
import { jkLib } from './jkCommon';

@Injectable({
  providedIn: 'root'
})
export class CodeService {

  constructor() { }
  doDeclareCS2TS(from: string, prefix: string): string {
    let to: string = '';
    let type: string;
    let field: string;
    let ps: string;
    let ms1: string;
    let ms2: string;
    let ary: string[] = from.split('\n');
    const typeNumber = 'LONG,ULONG,SHORT,USHORT,INT,UINT,BYTE,SBYTE,FLOAT,DOUBLE,DECIMAL,';
    const typeString = 'BSTR,STR,STRING';
    const typeBool = 'BOOL';
    for (let i = 0; i < ary.length; i++) {
      ms1 = ary[i].trim();
      //ms1.replaceAll(/\t/g, '    ');//替換 \t
      //ms1.replaceAll(/(?:^\t|(?<=^\t*)\t)/g, " ");
      ms1 = jkLib.replaceTab(ms1);
      if(ms1 === ''){
        to = to + jkLib.iif(to === '', '', jkLib.CR) ;
        continue;
      }
      //ms1.replace(/\t/g,' ');//替換 \t
      //ms1.replace(/\t/g,' ');//替換 \t
      let j = ms1.indexOf(';');
      if(j<0){
        to = to + jkLib.iif(to === '', '', jkLib.CR) + ms1;
        continue;
      }

      let a = jkLib.cutToken(ms1, ';');
      ms1 = a[0].trim();
      ps = a[1];
      a = jkLib.cutToken(ms1, ' ');
      type = a[0].trim().toUpperCase();
      field = a[1].trim();
      if (type !== '') {

        let idx = typeNumber.indexOf(type + ',');
        if (idx >= 0) {
          ms2 = '  ' + prefix + ' ' + field + ': number = 0 ; ' + ps;
          to = to + jkLib.iif(to === '', '', jkLib.CR) + ms2;
        }
        idx = typeString.indexOf(type + ',');
        if (idx >= 0) {
          ms2 = '  ' + prefix + ' ' + field + ': string = \'\' ; ' + ps;
          to = to + jkLib.iif(to === '', '', jkLib.CR) + ms2;
        }
        idx = typeBool.indexOf(type + ',');
        if (idx >= 0) {
          ms2 = '  ' + prefix + ' ' + field + ': boolean = \'\' ; ' + ps;
          to = to + jkLib.iif(to === '', '', jkLib.CR) + ms2;
        }
      }
    }
    return to;
  }
  /*doIdNameItemConvert(from: string): string {
    let result = '';
    let ms1: string = jkLib.swapStr(from,',',' ');

    let ary: string[] = from.split('\n');
    return result;
  }*/
}
